import { HiOutlineArrowRight, HiOutlineBookOpen } from "react-icons/hi2";
import { Link } from "react-router-dom";

import { CustomModal, Spinner } from "../shared";
import { useSupportArticles } from "../../lib/react-query/support";

export const SupportFaqModal = ({ open, onClose }) => {
  const { data: articles = [], isLoading } = useSupportArticles("", open);
  const publishedArticles = Array.isArray(articles) ? articles.slice(0, 6) : [];

  return (
    <CustomModal
      title="Frequently asked questions"
      open={open}
      close={onClose}
      showPrimaryButton={false}
      secondaryButtonText="Close"
      secondaryButtonClick={onClose}
      dialogSize="default"
    >
      <div data-support-modal="true">
        <div className="flex items-start gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-surface-hover text-primary">
            <HiOutlineBookOpen className="h-5 w-5" aria-hidden="true" />
          </span>
          <p className="text-sm leading-6 text-mediumgrey">
            Browse quick answers without leaving the page you were viewing.
          </p>
        </div>

        {isLoading ? (
          <div className="flex min-h-24 items-center justify-center">
            <Spinner />
          </div>
        ) : publishedArticles.length ? (
          <div className="mt-5 space-y-2">
            {publishedArticles.map((article) => (
              <details key={article.slug} className="rounded-xl border border-surface-border px-4 py-3">
                <summary className="cursor-pointer pr-4 text-sm font-semibold text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary">
                  {article.title}
                </summary>
                <p className="mt-2 whitespace-pre-line text-sm leading-6 text-mediumgrey">
                  {article.summary || article.body}
                </p>
              </details>
            ))}
          </div>
        ) : (
          <p className="mt-5 rounded-xl border border-dashed border-surface-border bg-surface/50 p-4 text-sm leading-6 text-mediumgrey">
            No FAQs have been published yet. Contact support if you still need help.
          </p>
        )}

        <Link
          to="/faq"
          onClick={onClose}
          className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-primary underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary"
        >
          View all FAQs
          <HiOutlineArrowRight className="h-4 w-4" aria-hidden="true" />
        </Link>
      </div>
    </CustomModal>
  );
};
